import { render, staticRenderFns } from "./CodingRuleDetailList.vue?vue&type=template&id=7b4aae5e&scoped=true&"
import script from "./CodingRuleDetailList.vue?vue&type=script&lang=js&"
export * from "./CodingRuleDetailList.vue?vue&type=script&lang=js&"
import style0 from "./CodingRuleDetailList.vue?vue&type=style&index=0&id=7b4aae5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4aae5e",
  null
  
)

export default component.exports